import { defineComponent as _defineComponent } from 'vue'
import {onBeforeMount, ref} from "vue";
import OtpComponent from "@/components/buyTokens/OtpComponent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPasswordStep2',
  props: {
  newPassword: {
    type: Object,
    required: true
  },
},
  emits: ['nextPage', 'prevPage', 'update:newPassword'],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

const props = __props;

onBeforeMount(() => {
  if (props.newPassword.email) {
    email.value = props.newPassword.email;
  }
});

const emit = __emit;
const email = ref<string>();
const activationCode = ref<string>();


const next = () => {
  emit('nextPage', {pageIndex: 1});
};


const __returned__ = { props, emit, email, activationCode, next, OtpComponent }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})